import { useState } from 'react';
import { useParams } from 'react-router-dom';

import TopModalSection from '../common/TopModalSection';

import Button from '@/components/ui/button';
import { UserRole } from '@/interfaces/api/user/UserRole.enum';
import { haggleApiService } from '@/services/haggle.service';
import { notificationService } from '@/services/notification.service';

type Props = {
	closeModal: () => void;
	refetch: () => void;
};

const AssignRoleModal = ({ closeModal, refetch }: Props) => {
	const [isLoading, setIsLoading] = useState(false);
	const { id } = useParams<{ id: string }>();

	const handleMakedAdminSubmit = async () => {
		if (!id) return;

		setIsLoading(true);
		try {
			await haggleApiService.assignRole(id, { role: UserRole.Admin });
			refetch();
			notificationService.success('Role assigned successfully');
			closeModal();
		} catch (error) {
			if (error instanceof Error) {
				notificationService.error(error.message);
			} else {
				notificationService.error(
					`Unknown error while trying to assign role to user: ${error}`,
				);
			}
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div
			className="flex flex-col justify-center items-center w-full"
			data-test="assign-role-modal"
		>
			<TopModalSection
				className="gap-x-4 border-b py-2 w-full px-4"
				title={'Make admin'}
				close={closeModal}
			/>
			<div className="p-4">
				<h1 className="text-sm font-medium text-gray-900 mb-[1rem]">
					Are you sure you want to grant this user administrator privileges?
				</h1>
				<div className="flex justify-around	">
					<Button
						size="mini"
						color="success"
						shape="rounded"
						transition="none"
						data-test="confirm-assign-role-button"
						onClick={handleMakedAdminSubmit}
					>
						Confirm
					</Button>
					<Button
						size="mini"
						color="danger"
						shape="rounded"
						transition="none"
						isLoading={isLoading}
						disabled={isLoading}
						data-test="cancel-assign-role-button"
						onClick={closeModal}
					>
						Cancel
					</Button>
				</div>
			</div>
		</div>
	);
};

export default AssignRoleModal;
